// M8.1 Connections merge — flag parser.
//
// Env var: VITE_CONNECTIONS_V2_ENABLED. Default OFF.
// Parser strictly `=== 'true'` per 2026-10-30 M7/M8 amendment §4
// per-surface flag contract. Anything else (undefined, 'false',
// 'TRUE', '1', '') is treated as OFF — the strict comparison is the
// hard contract so a misconfigured env can't accidentally expose
// the merged surface.
//
// Flag OFF: `/v2/connections` route is NOT registered in App.tsx.
//           Existing `/integrations` + `/admin/shopify-health` routes
//           render their shipped pages, byte-identical to pre-PR trunk.
// Flag ON:  `/v2/connections` renders the merged Connections surface.
//           Old routes STILL render their original pages — removal is a
//           separate cleanup PR after staging burn-in.

export function isConnectionsV2Enabled(): boolean {
  return import.meta.env.VITE_CONNECTIONS_V2_ENABLED === 'true';
}
